"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "What should I expect during my first chiropractic visit in Nicosia?",
  answer: "Your initial consultation involves a comprehensive health history review and a physical examination focusing on your spine and nervous system. We use this data to create a personalized treatment plan tailored to your specific wellness goals and lifestyle in Cyprus."
}, {
  question: "Do you provide services in both Limassol and Nicosia?",
  answer: "Yes, we operate modern clinics in both Limassol and Nicosia. This allows us to provide consistent, high-quality chiropractic care to patients across the island, ensuring you can access treatment wherever is most convenient for you."
}, {
  question: "Is chiropractic treatment safe for all ages?",
  answer: "Chiropractic care is a non-invasive, drug-free approach suitable for everyone from infants to seniors. Our techniques are adjusted for each individual's age, size, and specific health condition to ensure the safest and most effective results possible."
}, {
  question: "How many sessions will I need to see results?",
  answer: "The number of sessions varies depending on your condition, how long you've had it, and your body's unique healing rate. Many patients experience relief after just a few visits, while long-term wellness care helps maintain spinal health and prevent future issues."
}, {
  question: "Do I need a medical referral to book an appointment?",
  answer: "No, you do not need a referral from a GP to see a chiropractor in Cyprus. As primary healthcare providers, we are trained to diagnose and treat musculoskeletal conditions directly. You can contact our Nicosia or Limassol office to schedule your visit immediately."
}];
export default function AccountFaqs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="271" id="faq" ref={ref} className={cn("relative w-full py-24 overflow-hidden bg-background text-foreground transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,hsl(var(--accent)/0.08),transparent_70%)]" />
        <div className="absolute inset-0 opacity-[0.02] mix-blend-overlay" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
      }} />
      </div>

      <div className="container relative mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="mx-auto max-w-3xl">
          <h2 className="mb-12 text-center font-serif text-4xl md:text-5xl leading-tight tracking-tight text-foreground">
            Common Questions About Our Care
          </h2>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-border/60 last:border-0" data-index={i}>
                <AccordionTrigger className="py-6 text-lg font-medium transition-colors duration-300 hover:no-underline data-[state=open]:text-accent text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base leading-relaxed text-muted-foreground font-sans pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}